<template>
  <v-navigation-drawer
    v-model="drawer"
    color="primaryBgr"
    class="p-navigation-drawer--mini-variant"
    :permanent="isScreenXl"
    :expand-on-hover="!isScreenXl"
    app
    dark
  >
    <v-list class="p-nav-list px-4" nav>
      <v-list-item
        to="/"
        class="px-3"
      >
        <v-list-item-icon class="my-3">
          <v-img
            src="@/assets/images/logo-1.png"
            height="27"
            width="24"
            contain
          ></v-img>
        </v-list-item-icon>

        <v-list-item-content>
          <!-- <v-img
            src="@/assets/partitur.png"
            height="16"
            width="120"
            contain
          ></v-img> -->
          <v-list-item-title class="title">PARTITUR</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-for="item in drawerItems"
        :key="item.title"
        :to="{ name: item.route }"
        link
        class="px-3"
      >
        <v-list-item-icon class="my-3">
          <v-icon size="24" >{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>


<script>
import accessHelper from '@/helpers/access.helper'

import { mapGetters } from 'vuex'

import windowSizeMixin from '@/mixins/windowSize.mixin'


export default {
  mixins: [
    windowSizeMixin
  ],


  data: () => ({
    drawer: true
  }),


  computed: {
    ...mapGetters('user', ['currentUser', 'currentUserAndProjectClaims']),

    drawerItems () {
      if (process.env.NODE_ENV === 'production') {
        const allItems = [
          { title: this.$t('nav.projects'), icon: 'mdi-animation-outline', route: 'projects' },
          { title: this.$t('nav.members'), icon: 'mdi-account-multiple-outline', route: 'members' },
          { title: this.$t('nav.budget'), icon: 'mdi-currency-usd', route: 'budget' },
          { title: this.$t('nav.events'), icon: 'mdi-calendar-check-outline', route: 'events' },
          { title: this.$t('nav.documents'), icon: 'mdi-file-multiple-outline', route: 'documents' },
          { title: this.$t('nav.hours'), icon: 'mdi-clock-outline', route: 'hours' },
          { title: this.$t('nav.todo'), icon: 'mdi-check-outline', route: 'todo' },
          { title: this.$t('nav.marketing'), icon: 'mdi-bookmark-outline', route: 'marketing' },
          { title: this.$t('nav.communication'), icon: 'mdi-email-outline', route: 'communication' },
          { title: this.$t('nav.contacts'), icon: 'mdi-phone-outline', route: 'contacts' },
          { title: this.$t('nav.settings'), icon: 'mdi-cog-outline', route: 'settingsUsers' },
          { title: this.$t('nav.eventlog'), icon: 'mdi-pencil-circle-outline', route: 'eventlog' }
        ]
        const items = allItems.filter(item => accessHelper.isRouteAvailableForCurrentUserAndProject(item.route, this.currentUser, this.currentUserAndProjectClaims))
        return items
      } else {
        const allItems = [
          { title: this.$t('nav.dashboard'), icon: 'mdi-view-dashboard-outline', route: 'dashboard' },
          { title: this.$t('nav.projects'), icon: 'mdi-animation-outline', route: 'projects' },
          // { title: this.$t('nav.overview'), icon: 'mdi-eye-outline', route: 'overview' },
          { title: this.$t('nav.members'), icon: 'mdi-account-multiple-outline', route: 'members' },
          { title: this.$t('nav.budget'), icon: 'mdi-currency-usd', route: 'budget' },
          { title: this.$t('nav.events'), icon: 'mdi-calendar-check-outline', route: 'events' },
          { title: this.$t('nav.documents'), icon: 'mdi-file-multiple-outline', route: 'documents' },
          { title: this.$t('nav.hours'), icon: 'mdi-clock-outline', route: 'hours' },
          { title: this.$t('nav.todo'), icon: 'mdi-check-outline', route: 'todo' },
          { title: this.$t('nav.marketing'), icon: 'mdi-bookmark-outline', route: 'marketing' },
          { title: this.$t('nav.communication'), icon: 'mdi-email-outline', route: 'communication' },
          { title: this.$t('nav.contacts'), icon: 'mdi-phone-outline', route: 'contacts' },
          { title: this.$t('nav.settings'), icon: 'mdi-cog-outline', route: 'settingsUsers' },
          { title: this.$t('nav.eventlog'), icon: 'mdi-pencil-circle-outline', route: 'eventlog' }
        ]

        const items = allItems.filter(item => accessHelper.isRouteAvailableForCurrentUserAndProject(item.route, this.currentUser, this.currentUserAndProjectClaims))
        return items
      }
    }
  }
}
</script>
